import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
    map,
    catchError,
    switchMap,
    filter,
    withLatestFrom,
} from 'rxjs/operators';
import { ManagementApiService } from '../management-api.service';
import { ManagementStoreService } from '../management-store.service';
import * as RA from 'ramda-adjunct';
import * as R from 'ramda';
import {MmsAdminActions} from '@emm/management/store/mms-admin-override/mms-admin-override.actions';
import {NotificationService} from '@emm/shared/services/notification.service';

@Injectable({
    providedIn: 'root',
})
export class MmsAdminOverrideEffects {
    loadAllLocations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MmsAdminActions.loadAllLocation),
            switchMap(() =>
                this.api.getAllLocationSetsByTag('LOCATION').pipe(
                    map((locationSets) => MmsAdminActions.loadAllLocationSuccess({ locationSets })),
                    catchError(({ error }) => of(MmsAdminActions.loadAllLocationFailure({ error })))
                )
            )
        )
    );

    selectFromMmsAdmin$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MmsAdminActions.select),
            switchMap(() => of(MmsAdminActions.loadTemplateOptionsByLocation(), MmsAdminActions.loadTemplateByLocation()))
        )
    );

    loadTemplateOptionsByLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MmsAdminActions.loadTemplateOptionsByLocation),
            withLatestFrom(this.store.queryMmsAdminOverride.selected$),
            filter(
                ([_, selected]) =>
                    R.isNotEmpty(selected) && RA.isNotUndefined(selected)
            ),
            switchMap(([_, selected]) =>
                this.api.getSelectedOptionsByLocation(selected.tag).pipe(
                    map((template) => MmsAdminActions.loadTemplateOptionsByLocationSuccess({ template })),
                    catchError(({ error }) => of(MmsAdminActions.loadTemplateOptionsByLocationFailure({ error })))
                )
            )
        )
    );

    loadSelectionByLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MmsAdminActions.loadTemplateByLocation),
            withLatestFrom(this.store.queryMmsAdminOverride.selected$),
            filter(
                ([_, selected]) =>
                    R.isNotEmpty(selected) && RA.isNotUndefined(selected)
            ),
            switchMap(([_, selected]) =>
                this.api.getMenuSelectionOptionsByLocation(selected.tag).pipe(
                    map((template) => MmsAdminActions.loadTemplateByLocationSuccess({ template })),
                    catchError(({ error }) => of(MmsAdminActions.loadTemplateByLocationFailure({ error })))
                )
            )
        )
    );

    updateLocationSelections$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MmsAdminActions.savedSelections),
            switchMap(({selections, storeNumber, selectedEffectiveDate}) =>
                this.api.saveSelectedOptions(selections, storeNumber, selectedEffectiveDate).pipe(
                    map((response) => {
                        MmsAdminActions.savedSelectionsSuccess(response);
                        this.notificationService.success('Saved Successfully');
                    }),
                    catchError(({ error }) => of(MmsAdminActions.SavedSelectionsFailure({ error }))),
                    map(() => MmsAdminActions.loadTemplateOptionsByLocation())
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private api: ManagementApiService,
        private store: ManagementStoreService,
        private notificationService: NotificationService,
    ) {}
}
